import styled from 'styled-components';
import { colorAppBackground, colorAppError } from 'common/styles/colors';
import { containerPaddingM } from 'common/styles/variables';

export const ErrorMessage = styled.div`
    display: flex;
    align-items: center;
    padding: ${containerPaddingM};
    background: ${colorAppBackground};
    color: ${colorAppError};
`;

export const ErrorMessageText = styled.p`
    margin-left: 0.5rem;
`;
